import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import EditorContext from '../../containers/editor-context';
import ButtonItem from './widgets/button-item';
import ButtonGroup from './widgets/button-group';
import HeaderList from './header-list';
import InsertTable from './insert-table';
import InsertImage from './insert-image';
import TableGroup from './table-group';
import AddLinkDialog from '../dialogs/add-link-dialog';
import AddImageDialog from '../dialogs/add-image-dialog';
import AddFormulaDialog from '../dialogs/add-formula-dialog';
import ColumnIcon from '../svg-icons/column-icon';
import '../../assets/css/topbar.css';
var Toolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(Toolbar, _React$Component);
  var _super = _createSuper(Toolbar);
  function Toolbar(props) {
    var _this;
    _classCallCheck(this, Toolbar);
    _this = _super.call(this, props);
    _this.onClickHeader = function (event, type) {
      event.preventDefault();
      _this.editorUtils.clickHeader(type);
    };
    _this.onClickMark = function (type) {
      return function (event) {
        event.preventDefault();
        _this.editorUtils.clickMark(type);
      };
    };
    _this.onClickBlock = function (type) {
      return function (event) {
        event.preventDefault();
        _this.editorUtils.clickBlock(type);
      };
    };
    _this.onClearFormat = function (event) {
      event.preventDefault();
      _this.editorUtils.clearFormat();
    };
    _this.onClickCheckItem = function (event) {
      event.preventDefault();
      _this.editorUtils.clickCheckItem();
    };
    _this.onAddTable = function (event, rowCount, columnCount) {
      event.preventDefault();
      _this.editorUtils.addTable(rowCount, columnCount);
    };
    _this.onInsertImage = function (data) {
      _this.editorUtils.insertImage(data);
    };
    _this.onAddCustomColumn = function (event) {
      event.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
      _this.editorUtils.addCustomColumn();
    };
    _this.onRemoveTable = function (event) {
      event.preventDefault();
      _this.editorUtils.removeTable();
    };
    _this.onInsertColumn = function (event) {
      event.preventDefault();
      _this.editorUtils.insertColumn();
    };
    _this.onRemoveColumn = function (event) {
      event.preventDefault();
      _this.editorUtils.removeColumn();
    };
    _this.onInsertRow = function (event) {
      event.preventDefault();
      _this.editorUtils.insertRow();
    };
    _this.onRemoveRow = function (event) {
      event.preventDefault();
      _this.editorUtils.removeRow();
    };
    _this.onSetAlign = function (event, align) {
      event.preventDefault();
      _this.editorUtils.setAlign(align);
    };
    _this.onToggleLink = function (event) {
      event.preventDefault();
      var isLinkActive = _this.editorUtils.isLinkActive();
      if (!isLinkActive) {
        _this.setState({
          isShowLinkDialog: !_this.state.isShowLinkDialog
        });
        return;
      }
      _this.editorUtils.unwrapLink();
    };
    _this.onToggleLinkDialog = function () {
      _this.setState({
        isShowLinkDialog: !_this.state.isShowLinkDialog
      });
    };
    _this.onToggleFormulaDialog = function () {
      _this.setState({
        isShowFormulaDialog: !_this.state.isShowFormulaDialog
      });
    };
    _this.onToggleImageDialog = function () {
      _this.setState({
        isShowImageDialog: !_this.state.isShowImageDialog
      });
    };
    _this.state = {
      isShowLinkDialog: false,
      isShowImageDialog: false,
      isShowFormulaDialog: false
    };
    _this.editorUtils = EditorContext.getEditorUtils();
    window.abcdef_editorToolbar = _assertThisInitialized(_this);
    return _this;
  }
  _createClass(Toolbar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        hasSidePanel = _this$props.hasSidePanel,
        isShowSidePanel = _this$props.isShowSidePanel,
        canInsertColumn = _this$props.canInsertColumn,
        t = _this$props.t;
      var toolbarStatus = this.editorUtils.getToolbarStatus();
      var isTableActive = toolbarStatus.isTableActive,
        isCodeActive = toolbarStatus.isCodeActive,
        isBoldActive = toolbarStatus.isBoldActive,
        isItalicActive = toolbarStatus.isItalicActive,
        isInlineCodeActive = toolbarStatus.isInlineCodeActive,
        isLinkActive = toolbarStatus.isLinkActive,
        isBlockquoteActive = toolbarStatus.isBlockquoteActive,
        isOrderedListActive = toolbarStatus.isOrderedListActive,
        isUnorderedListActive = toolbarStatus.isUnorderedListActive,
        isCheckListActive = toolbarStatus.isCheckListActive,
        isFormulaActive = toolbarStatus.isFormulaActive,
        isColumnActive = toolbarStatus.isColumnActive;
      var isListActive = isOrderedListActive || isUnorderedListActive || isCheckListActive;
      var sidePanelText = isShowSidePanel ? t('Hide_side_panel') : t('Show_side_panel');
      var _this$state = this.state,
        isShowLinkDialog = _this$state.isShowLinkDialog,
        isShowImageDialog = _this$state.isShowImageDialog,
        isShowFormulaDialog = _this$state.isShowFormulaDialog;
      var isHeadActive = toolbarStatus.headerType !== 'paragraph';
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: 'sf-editor-toolbar ' + (this.props.isSimpleEditor ? '' : 'rich-menu')
      }, /*#__PURE__*/React.createElement("div", {
        className: 'button-container'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'header-list-container'
      }, /*#__PURE__*/React.createElement(HeaderList, {
        disabled: isFormulaActive || isCodeActive || isColumnActive || isTableActive,
        headerType: toolbarStatus.headerType,
        onClickHeader: this.onClickHeader
      })), /*#__PURE__*/React.createElement(ButtonGroup, {
        className: 'editor-btn-group'
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isCodeActive || isColumnActive,
        isRichEditor: true,
        text: t('italic'),
        id: 'ITALICButton',
        icon: 'iconfont icon-italic',
        isActive: isItalicActive,
        onMouseDown: this.onClickMark('ITALIC')
      }), /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isCodeActive || isColumnActive,
        isRichEditor: true,
        text: t('bold'),
        id: 'BOLDButton',
        icon: 'iconfont icon-bold',
        isActive: isBoldActive,
        onMouseDown: this.onClickMark('BOLD')
      }), /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isCodeActive || isColumnActive,
        isRichEditor: true,
        text: t('code'),
        id: 'CODEButton',
        icon: 'iconfont icon-code',
        isActive: isInlineCodeActive,
        onMouseDown: this.onClickMark('CODE')
      }), /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isCodeActive || isColumnActive,
        isRichEditor: true,
        text: t('insert_link'),
        id: 'linkButton',
        icon: 'iconfont icon-link',
        isActive: isLinkActive,
        onMouseDown: this.onToggleLink
      })), /*#__PURE__*/React.createElement(ButtonGroup, {
        className: 'editor-btn-group'
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isTableActive || isColumnActive || isCodeActive,
        isRichEditor: true,
        text: t('quote'),
        id: 'block-quoteButton',
        icon: 'iconfont icon-quote-left',
        isActive: isBlockquoteActive,
        onMouseDown: this.onClickBlock('blockquote')
      }), /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isTableActive || isColumnActive || isCodeActive,
        isRichEditor: true,
        text: t('ordered_list'),
        id: 'ordered_listButton',
        icon: 'iconfont icon-list-ol',
        isActive: isOrderedListActive,
        onMouseDown: this.onClickBlock('ordered_list')
      }), /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isTableActive || isColumnActive || isCodeActive,
        isRichEditor: true,
        text: t('unordered_list'),
        id: 'unordered_listButton',
        icon: 'iconfont icon-list-ul',
        isActive: isUnorderedListActive,
        onMouseDown: this.onClickBlock('unordered_list')
      }), !canInsertColumn && /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isTableActive || isColumnActive || isCodeActive,
        isRichEditor: true,
        text: t('check_list_item'),
        id: 'checkListItemButton',
        icon: 'iconfont icon-check-square',
        isActive: isCheckListActive,
        onMouseDown: this.onClickCheckItem
      })), /*#__PURE__*/React.createElement(ButtonGroup, {
        className: 'editor-btn-group'
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isTableActive || isColumnActive || isHeadActive,
        isRichEditor: true,
        text: t('code_block'),
        id: 'codeButton',
        icon: 'iconfont icon-code-block',
        isActive: isCodeActive,
        onMouseDown: this.onClickBlock('code_block')
      }), /*#__PURE__*/React.createElement(InsertTable, {
        disabled: isFormulaActive || isCodeActive || isTableActive || isColumnActive,
        isRichEditor: true,
        text: t('insert_table'),
        id: 'tableButton',
        icon: 'iconfont icon-table',
        onAddTable: this.onAddTable
      }), window.canInsertFormula && /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isCodeActive || isTableActive || isColumnActive || isHeadActive || isListActive,
        isRichEditor: true,
        text: t('insert_formula'),
        id: 'formulaButton',
        icon: 'iconfont icon-formula',
        onMouseDown: this.onToggleFormulaDialog
      }), /*#__PURE__*/React.createElement(InsertImage, {
        disabled: isFormulaActive || isCodeActive || isColumnActive || isHeadActive,
        text: 'insert_image',
        id: 'insertImageButton',
        insertRepoFile: this.props.insertRepoFile,
        toolbarStatus: this.props.toolbarStatus,
        onInsertImage: this.onInsertImage,
        onToggleImageDialog: this.onToggleImageDialog
      }), canInsertColumn && /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: isFormulaActive || isTableActive || isHeadActive,
        isRichEditor: true,
        text: t('Insert_column'),
        id: 'insertColumn',
        className: "svg-button",
        onMouseDown: this.onAddCustomColumn,
        isActive: isCodeActive,
        image: ColumnIcon
      })), isTableActive && /*#__PURE__*/React.createElement(TableGroup, {
        onRemoveTable: this.onRemoveTable,
        onInsertColumn: this.onInsertColumn,
        onRemoveColumn: this.onRemoveColumn,
        onInsertRow: this.onInsertRow,
        onRemoveRow: this.onRemoveRow,
        onSetAlign: this.onSetAlign
      }), /*#__PURE__*/React.createElement(ButtonGroup, {
        className: 'editor-btn-group'
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        className: 'editor-clear-format',
        isRichEditor: true,
        text: t('Clear_format'),
        id: 'clearButton',
        icon: 'iconfont icon-clear-format',
        onMouseDown: this.onClearFormat
      }))), hasSidePanel && /*#__PURE__*/React.createElement("div", {
        className: "button-container"
      }, !this.props.isShowSidePanel && /*#__PURE__*/React.createElement(ButtonGroup, {
        className: "editor-btn-group position-absolute dropdown-menu-right"
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        isRichEditor: true,
        text: sidePanelText,
        id: "showSidePanel",
        icon: "iconfont icon-angle-double-left",
        isActive: false,
        onMouseDown: this.props.toggleSidePanel
      })), this.props.isShowSidePanel && /*#__PURE__*/React.createElement(ButtonGroup, {
        className: "editor-btn-group position-absolute dropdown-menu-right"
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        isRichEditor: true,
        text: sidePanelText,
        id: "hideSidePanel",
        icon: "iconfont icon-angle-double-right",
        isActive: false,
        onMouseDown: this.props.toggleSidePanel
      })))), isShowLinkDialog && /*#__PURE__*/React.createElement(AddLinkDialog, {
        toggleLinkDialog: this.onToggleLinkDialog
      }), isShowFormulaDialog && /*#__PURE__*/React.createElement(AddFormulaDialog, {
        toggleFormulaDialog: this.onToggleFormulaDialog
      }), isShowImageDialog && /*#__PURE__*/React.createElement(AddImageDialog, {
        insertImage: this.onInsertImage,
        onToggleImageDialog: this.onToggleImageDialog
      }));
    }
  }]);
  return Toolbar;
}(React.Component);
export default withTranslation('seafile-editor')(Toolbar);